import styled from "styled-components";

export const StyledMatchGroup = styled.div`
  & > div:not(:first-of-type, :last-of-type) {
    border-bottom: 1px solid #dddddd;
  }
`;

export const StyledMatchListWrapper = styled.div`
  width: 100%;

  .mls-c-match-list__match-competition {
    display: none;
  }

  .mls-c-club__abbreviation {
    display: none;
  }

  &.xs,
  &.xxs,
  &.sm {
    .mls-c-match-list__match-broadcaster__wrapper {
      margin-top: 8px;
    }

    .mls-c-match-list__match-watch-live-button {
      display: none;
    }

    .mls-c-match-list__match-watch-live-icon {
      display: flex;
    }

    .mls-c-match-list__match-competition {
      display: flex;
    }

    .mls-c-club__abbreviation {
      display: block;
    }

    .mls-c-club__shortname {
      display: none;
    }

    .mls-c-match-list__match-info {
      display: none;
    }

    .mls-c-match-list__match-watch {
      width: 72px;
    }

    .mls-c-match-list__match-watch-label {
      display: none;
    }

    .mls-c-match-list__match-cta {
      width: 24px;
      height: 24px;
      padding: 0;

      > img {
        margin: 0;
      }

      svg {
        margin: 0;
      }
    }

    .mls-c-match-list__match-hotel-book-label {
      display: none;
    }

    .mls-c-match-tile {
      width: auto;
    }
  }

  &.xxs {
    .mls-c-club__abbreviation {
      display: none;
    }
  }
`;

export const StyledMatchHeaderWrapper = styled.div`
  scroll-margin-top: 80px;
`;
